// Re-selects the clusters a shared ?h3Ids= URL names once they are on the map.
// Used by the search page and the favourites map, which restore the same way.
export function restoreClusterSelection(
	h3Ids: readonly string[] | undefined,
	clusters: readonly { geometry: { id: string } }[],
	isSelected: (clusterId: string) => boolean,
	select: (clusterId: string) => void
): void {
	if (!h3Ids?.length || !clusters.length) return;

	const wanted = new Set(h3Ids);
	for (const cluster of clusters) {
		const clusterId = cluster.geometry.id;
		if (wanted.has(clusterId) && !isSelected(clusterId)) select(clusterId);
	}
}
